export default "__VITE_ASSET__ysIN2RLv__"